var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var availablePermissions = [
    'create',
    'update',
    'read',
    'delete',
    'permission',
];
export var hasDrafts = function (meta) { return meta && meta.hasDrafts; };
export var hasPermission = function (meta, permission) {
    var metaObj = meta;
    if (meta instanceof Function) {
        metaObj = meta();
    }
    if (metaObj && Array.isArray(metaObj.allowed_actions)) {
        return metaObj.allowed_actions.includes(permission);
    }
    return false;
};
export var makeColumnsWithPermission = function (columns, meta) {
    return columns.reduce(function (acc, column) {
        if (column.permission) {
            if (!hasPermission(meta, column.permission)) {
                return acc;
            }
        }
        return __spreadArray(__spreadArray([], acc, true), [column], false);
    }, []);
};
var navigate = null;
export var redirect403 = function () {
    if (navigate) {
        navigate('/403');
    }
    else {
        window.location = '/403';
    }
};
export var injectNavigation = function (newNavigationFunction) {
    navigate = newNavigationFunction;
};
export var withPermission = function (meta, permission, cb) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (hasPermission(meta, permission) && cb) {
            return cb.apply(void 0, args);
        }
        if (redirect403)
            return redirect403();
        return null;
    };
};
